<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-4">
    <div class="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6">
        <div class="text-center mb-6">
            <div class="w-14 h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <svg class="w-7 h-7 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path></svg>
            </div>
            <h1 class="text-2xl font-bold text-gray-800">Pilih Outlet</h1>
            <p class="text-sm text-gray-500 mt-1">Pilih outlet yang ingin Anda kelola</p>
        </div>

        <div class="space-y-3">
            <div *ngFor="let outlet of outlets"
                (click)="selectOutlet(outlet)"
                class="p-4 border border-gray-200 rounded-xl cursor-pointer hover:border-emerald-400 hover:bg-emerald-50 transition-all group">
                <div class="flex items-center gap-3">
                    <div class="w-11 h-11 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
                        <span class="text-emerald-700 font-bold text-sm">{{ outlet.code || (outlet.name | slice:0:2).toUpperCase() }}</span>
                    </div>
                    <div class="flex-1 min-w-0">
                        <h3 class="font-semibold text-gray-800 group-hover:text-emerald-700 transition-colors truncate">
                            {{ outlet.name }}
                        </h3>
                        <p class="text-xs text-gray-400 truncate">{{ outlet.address || 'Outlet' }}</p>
                    </div>
                    <svg class="w-5 h-5 text-gray-300 group-hover:text-emerald-500 transition-colors flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" /></svg>
                </div>
            </div>
        </div>

        <p class="text-gray-400 text-xs text-center mt-6">
            © 2026 <span class="font-semibold">AWH</span> . Powered by <span class="font-semibold">PT. AWH Inti Nusantara.</span>
        </p>
    </div>
</div>
